import createDependenciesCollector from "./utils/create-dependencies-collector";

const getForConferenceRankV2 = createDependenciesCollector(["ConferenceSelectionV2", "TabbedConferenceSelection"]);

export default getForConferenceRankV2;
